export enum BuyApartmentFlowPaths {
  chooseMode = '/choose-mode',
  main = '/buy',
  buySecondary = '/buy-secondary',
  buySecondaryStreetMap = '/buy-secondary/street-map',
  tradeIn = '/buy/trade-in',
  chooseApartmentComplex = '/buy/apartment-complex',
  chooseNumberOfRooms = '/buy/rooms-number',
  chooseApartmentPlan = '/buy/apartment-plan',
  chooseSqFootage = '/buy/apartment-square-footage',
  choosePriceRange = '/buy/price-range',
  aparmentDeals = '/buy/apartments',
  apartmentListBuySecondary = '/buy-secondary/apartments-list',
  apartment = '/buy/apartment',
  apartmentNavigation = '/buy/apartment/:id',
  apartmentSecondary = '/buy/apartment-secondary',
  apartmentSecondaryNavigation = '/buy/apartment-secondary/:id',
  apartmentFilters = '/buy/apartment-filters',
  apartmentFiltersSecondary = '/buy-secondary/apartment-filters',
  apartmentSort = '/buy/apartment-sort',
  apartmentSortSecondary = '/buy-secondary/apartment-sort',
  favoritesFacilityList = '/buy/favorites-facility-list',
  apartmentFavorites = '/buy/apartment-favorites',
  apartmentFavoritesUsers = "/buy/apartment-favorites-users", 
  requests = '/buy/requests',
  image = '/buy/image',
  choosePriceRangeSecondary = '/buy-secondary/price-range',
  chooseNumberOfRoomsSecondary = '/buy-secondary/rooms-number',
  chooseSqFootageSecondary = '/buy-secondary/apartment-square-footage',
}

export enum SellApartmentFlowPaths {
  main = '/sell',
  mainSellChooseMode = '/sell/choose-mode',
  chooseApartmentComplex = '/sell/apartment-complex',
  secondaryTabAddress = '/sell-secondary/tab-address',
  chooseBuilding = '/sell/building',
  inputApartmentNumber = '/sell/apartment-number',
  inputApartmentPrice = '/sell/apartment-price',
  apartmentSaleAds = '/sell/my-ads',
  apartment = '/sell/apartment',
  addAdditionalOptions = '/sell/add-additional-options',
  sellNotificationModeId = '/sell/apartment-notification-mode/:id',
  sellNotificationMode = '/sell/apartment-notification-mode',
  documents = '/sell/documents',
  documentsNotificationMode = '/sell/documents-notification-mode',
  sellFinishScreen = '/sell/finish',
  sellReitInformation = '/sell/reit-information',
  sellTradeInInformation = '/sell/trade-in-information',
  apartmentSaleAdsSecondary = '/sell-secondary/my-ads',
  chooseApartmentSecondary = '/sell-secondary/choose-apartment',
  priceSecondaryScreen = '/sell-secondary/price',
  uploadPhotoSecondary = '/sell-secondary/upload-photo',
}

export enum NotificationFlowPaths {
  main = '/notification',
  notificationFilterItem = '/notification/filter-item',
  notificationFilterItemNavigation = '/notification/filter-item/:id',
  notificationCreateFilter = '/notification/create-filter',
  notificationCreateFilterSecondary = '/notification/create-filter-secondary',
}

export enum TemporaryPaths {
  main = '/temporary',
  temporaryList = '/temporary/list',
}

export enum CommonPaths {
  contacts = '/contacts',
  estimate = '/estimate',
  home = '/home',
}
